import './style.scss';

// Slider
import { tns } from "tiny-slider"

// GSAP
import { gsap } from 'gsap';

document.addEventListener( 'DOMContentLoaded', () => {
	// Image Laziness
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete == true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );
	
	// Year in copyright message
	document.querySelectorAll( "footer .copyright" ).forEach( ( div ) => {
		const today = new Date();
		div.innerHTML = div.innerHTML.replace( /{YEAR}/i, today.getFullYear() );
	} );

	// Sliders
	document.querySelectorAll( '.wp-block-group.is-style-slider' ).forEach( ( slides ) => {
		const slider = tns( {
			container: slides,
			mode: 'gallery',
			items: 1,
			slideBy: 'page',
			autoplay: false,
			autoplayButton: false,
			nav: 'true',
			navPosition: 'bottom',
			controlsPosition: 'bottom',
			controlsText: [ '<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>' ]
		} );
		
		slides.closest( '.tns-outer' ).classList.add( 'is-style-slider-tns' );
	} );
	
	// Match Media for Sliders
	let mm = gsap.matchMedia();
	mm.add("(min-width: 600px)", () => {
		document.querySelectorAll( '.wp-block-ordered-exhibitions-template.is-slider, .wp-block-post-template.is-slider' ).forEach( ( slides ) => {
			const slider = tns( {
				container: slides,
				mode: 'carousel',
				items: 1,
				slideBy: 'page',
				autoplay: false,
				autoplayButton: false,
				autoHeight: true,
				nav: false,
				loop: false,
				gutter: 20,
				controlsPosition: 'top',
				controlsText: [ '<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>' ],
				responsive: {
					600: {
						items: 2,
						gutter: 28
					},
					992: {
						items: 3,
						gutter: 45
					},
					1200: {
						gutter: 66
					}
				}
			} );
			slides.closest( '.tns-outer' ).classList.add( 'show-overflow' );
		} );
	} );


	
	// Arrow position
	window.setTimeout( () => {
		adjustGetwidControls();
	}, 500 );

	window.addEventListener( 'resize', () => {
		adjustGetwidControls();
	} );

	// Core/Navigation not adding 'current-menu-item' to some pages
	document.querySelectorAll( 'main .wp-block-navigation-item' ).forEach( link => {
		const a = link.querySelector( "& > a" );
		
		if( a && a.href.replace(/\/$/, "") === window.location.href.replace(/\/$/, "") ) {
			// Add to current 
			link.classList.add( 'current-menu-item' );	
			// Add to nearest parent (if it exists)
			link.closest( 'li.wp-block-navigation-submenu' )?.classList.add( 'current-menu-ancestor');
			link.closest( 'li.wp-block-navigation-submenu' )?.closest( 'li.wp-block-navigation-submenu' )?.classList.add( 'current-menu-ancestor');
		}
	} );


	// Parent Navigation 
	// This isn't present in wp-block-navigation currently
	document.querySelectorAll( 'main .wp-block-navigation-item.current-menu-item' ).forEach( ( link ) => {
		link.parentNode.closest( '.wp-block-navigation-item' )?.classList.add( 'current-menu-ancestor' );
	} );

	// ROI Form Autofill
	let params = new URLSearchParams( document.location.search );
	if( params.get( 'exhibition_title' ) ) {
		const title = params.get( 'exhibition_title' );
		if( document.querySelector( '.roi_exhibition_title input' ) ) {
			document.querySelector( '.roi_exhibition_title input' ).value = title;
		}
	}

	// Query appearance
	document.querySelectorAll( '.wp-block-query-appearance select' ).forEach( ( select ) => {
		select.addEventListener( 'change', ( e ) => { 
			const appearance = e.target.value;
			// const url = window.location.origin + window.location.pathname + '&query-appearance=' + appearance;
			// window.location = url;
			const url = new URL( window.location );
			url.searchParams.set( 'query-appearance', appearance );
			window.history.pushState( {}, '', url );

			if( appearance == 'list' ) {
				document.body.classList.remove( 'query-appearance-grid' );
				document.body.classList.add( 'query-appearance-list' );
			}
			else {
				document.body.classList.remove( 'query-appearance-list' );
				document.body.classList.add( 'query-appearance-grid' );
			}
		} );
	} );

	// Header height
	// iOS window height work around  
  window.addEventListener( 'resize', bones_theme_window_height );
  bones_theme_window_height();

	// Big Navigation
	// const popupNav = document.querySelector( '#header-menu-popup .wp-block-navigation__responsive-container-content' );
	// document.querySelectorAll( '#header-menu-items .wp-block-navigation__container > .wp-block-navigation-item' ).forEach( ( link, i ) => {
	// 	link.dataset['index'] = i;
	// 	link.addEventListener( 'mouseenter', ( e ) => {
	// 		const j = e.target.dataset['index'];
	// 		popupNav.querySelector( '.wp-block-navigation__container > .wp-block-navigation-item.show-me' )?.classList.remove( 'show-me' );
	// 		popupNav.querySelectorAll( '.wp-block-navigation__container > .wp-block-navigation-item' )[j].classList.add( 'show-me' );
	// 	} );
	// } );

	// Header Search
	document.querySelectorAll( '#header-search a' ).forEach( ( button ) => {
		button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			document.body?.classList.remove( 'show-header-signup' );
			document.body?.classList.toggle( 'show-header-search-bar' );
		} );
	} );

	document.querySelectorAll( '#header-signup a' ).forEach( ( button ) => {
		button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			document.body?.classList.remove( 'show-header-search-bar' );
			document.body?.classList.toggle( 'show-header-signup' );
		} );
	} );

	// Close Header Search
	document.querySelector( '.hide-header-search-bar a' )?.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		document.body?.classList.remove( 'show-header-search-bar' );
	} );

	document.querySelector( '.hide-header-signup a' )?.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		document.body?.classList.remove( 'show-header-signup' );
	} );

	// Keyboard Triggers
	document.addEventListener( 'keydown', ( event ) => {
		const keyName = event.key;
		// Close Header Search
		if( keyName == 'Escape' && document.body.classList.contains( 'show-header-search-bar' ) ) {
			document.body?.classList.remove( 'show-header-search-bar' );
		}
		if( keyName == 'Escape' && document.body.classList.contains( 'show-header-signup' ) ) {
			document.body?.classList.remove( 'show-header-signup' );
		}
	} );

	// Smooth scroll
	document.querySelectorAll( 'a' ).forEach( ( link ) => {
		if( link.hash.length > 1 ) {
			link.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				if( document.querySelector( e.target.hash ) ) {
					document.querySelector( e.target.hash ).scrollIntoView( { behavior: 'smooth' } );
				}
			} );
		}
	} );

	document.body.addEventListener( 'click', ( e ) => {
		console.log( e.target );
	} );

	// Ack Country
	document.querySelectorAll( '#acknowledgement-of-country a' ).forEach( ( a ) => {
		a.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			document.querySelector( 'footer.wp-block-template-part.acknowledgement-of-country' )?.classList.remove( 'is-visible' );
		} );
	} );

	document.addEventListener('keydown', ( e ) => {
		if( e.code == 'Escape' ) {
			document.querySelector( 'footer.wp-block-template-part.acknowledgement-of-country' )?.classList.remove( 'is-visible' );
		}
	} );

	const month = 30 * 24 * 60 * 60 * 1000;
	const now = new Date();
	let showAcknowledgement = false;
	if( localStorage.getItem( 'showAcknowledgement' ) ) {
		const lastShown = parseInt( localStorage.getItem( 'showAcknowledgement' ) );
		// Show if it's been a month
		if ( now.getTime() > lastShown + month ) {
			showAcknowledgement = true;
		}
	}
	else {
		showAcknowledgement = true;
	}

	if( showAcknowledgement && document.querySelector( 'footer.wp-block-template-part.acknowledgement-of-country' ) ) {
		// Show popup
		document.querySelector( 'footer.wp-block-template-part.acknowledgement-of-country' ).classList.add( 'is-visible' );
		// Set/Reset next time
		localStorage.setItem( 'showAcknowledgement', now.getTime() + month );
	}
} );

const adjustGetwidControls = () => {
	// Adjust arrows
	document.querySelectorAll( '.wp-block-getwid-media-text-slider.is-style-copy-aligned-bottom' ).forEach( ( slides ) => {
		// console.log( slides );
		if( slides.querySelector( '.wp-block-getwid-media-text-slider-slide-content__media' ) ) {
			const image = slides.querySelector( '.wp-block-getwid-media-text-slider-slide-content__media img.has-loaded' );
			slides.querySelectorAll( '.slick-arrow' ).forEach( ( button ) => {
				button.classList.add( 'is-moved' );
				button.style.top = Math.floor( image.offsetHeight / 2 ) + 'px';
			} );
		}
	} );
} 

// iOS window height
const bones_theme_window_height = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);

	if( document.querySelector( 'header' ) ) {
		let offsetHeight = 0;
		document.querySelectorAll( 'header' ).forEach( ( header ) => { 
			offsetHeight += header.offsetHeight;
		} );
		doc.style.setProperty('--app-fixed-header-height', `${offsetHeight}px`);
		doc.style.setProperty('--app-header-height', `${document.querySelector( 'header' ).offsetHeight}px`);
	}
}